<template>
  <div class="flex flex-col gap-y-3">
    <strong>{{ state.model?.number }}</strong>
    <c_cell title="供应商">
      <template #default>
        <div class="flex gap-x-3">
          <text>{{ state.model?.supplier?.name }}</text>
          <li class="flex gap-x-3 text-xs text-gray-400">
            <text>{{ state.model?.supplier?.number }}</text>
            <text>{{ state.model?.supplier?.contact_name }}</text>
            <c_sex
              :value="
                state.model?.supplier?.contact_title == '先生' ? '男' : '女'
              "
            />
            <text>{{
              $phoneFormat(state.model?.supplier?.contact_phone)
            }}</text>
          </li>
        </div>
      </template>
    </c_cell>
    <ul class="flex gap-x-5">
      <c_cell title="付款方式" :value="state.model?.d_payment_type_name" />
      <c_cell title="收款信息">
        <template #default>
          <div class="flex gap-x-2">
            <text>{{ state.model?.supplierBankAccount?.opening_bank }}</text>
            <text class="text-gray-400">{{
              state.model?.supplierBankAccount?.name
            }}</text>
            <text class="text-gray-400">{{
              state.model?.supplierBankAccount?.account
            }}</text>
          </div>
        </template>
      </c_cell>
    </ul>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <strong>采购明细</strong>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <el-table-column fixed label="#" width="70" type="index" align="center" />
      <el-table-column>
        <template #header>
          <div
            class="c-table-col-header"
            label1="采购名称"
            label2="采购单号/类型/创建人"
          />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <strong>{{ row.name }}</strong>
              <text class="text-xs text-gray-400 ml-1">{{ row.number }}</text>
              <text class="text-xs text-gray-400 ml-1">
                {{ row.d_cost_type_pname }}
              </text>
            </template>
            <template #bottom>
              <div class="flex items-center text-gray-400 text-xs gap-x-2">
                <text class="text-sm text-gray-600">
                  {{ row?.add_admin_name }}
                </text>
                <text>{{ row?.add_department_name }}</text>
                <text class="ml-1">{{ row?.create_time }} 创建</text>
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :min-width="160">
        <template #header>
          <div
            class="c-table-col-header"
            label1="所属会议"
            label2="状态/项目编号"
          />
        </template>
        <template #default="{ row }">
          <c_tabgroup :value1="row.meeting?.name" :value2="row.number">
            <template #bottom>
              <div class="flex gap-x-2">
                <c_status
                  arrName="Meeting_Status"
                  :value="row.meeting?.status"
                  :key="row.meeting?.status"
                />
                <text class="text-xs text-gray-400">{{
                  row.meeting?.number
                }}</text>
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="结算价" :width="120" align="center">
        <template #default="{ row }">
          <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
        </template>
      </el-table-column>
      <el-table-column label="已付" :width="120" align="center">
        <template #default="{ row }">
          <text class="text-blue-400">{{ $priceFormat(row.paid_amount) }}</text>
        </template>
      </el-table-column>
      <el-table-column
        label="应付"
        prop="unpaid_amount"
        :width="120"
        align="center"
        :formatter="$tab_MoneyFormat"
      />
      <el-table-column label="本次付款" fixed="right" align="right">
        <template #default="{ row }">
          <el-input-number
            v-model="row.this_amount"
            :precision="2"
            class="number-input-left number-input-suffix !w-28"
            suffix="元"
            @focus="$onFocus"
            @change="onMoneyChange(row)"
          ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
    <strong>审核进度</strong>
    <el-steps :active="state.model.status" align-center>
      <el-step title="业务添加" :description="state.model.create_time" />
      <el-step title="部门初审" />
      <el-step title="财务审核" />
      <el-step title="出纳付款" />
    </el-steps>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { supplier_purchase_payment_apply_detail } from "@/http/supplier";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
      list_data: [],
    });
    onMounted(() => {
      if (props.id) {
        supplier_purchase_payment_apply_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
          }
        });
      }
    });
    return { state };
  },
};
</script>
<style scoped></style>
